import { CDN_URL } from '@karma/utils/constants/env';
import VideoPlayerWithControls from 'components/organisms/VideoPlayerWithControls/VideoPlayerWithControls';

const ModalBodyVideoHowToSave = () => <VideoPlayerWithControls url={`${CDN_URL}/videos/save-item-2.mp4`} />;

export default ModalBodyVideoHowToSave;
